module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/SimplyCLICK SBI Card.4a7d9b89.png";